import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const SectionHeading = ({
  heading,
  subHeading,
  style,
  t,
  paddingLeftStyle = {
    xs: "17px",
    sm: "17px",
    md: "17px",
    lg: "0px",
    xl: "0px",
  },
}) => {
  return (
    <Grid sx={style}>
      <Typography
        sx={{
          // textAlign: textCenter('underLg')
          wordBreak: "break-all",
          paddingLeft: paddingLeftStyle,
        }}
        fontSize={"24px"}
        fontWeight={600}
        fontFamily={"Sitka Heading"}
      >
        {t(heading)}
      </Typography>
      <Typography
        sx={{
          // textAlign: textCenter('underLg'),
          paddingLeft: paddingLeftStyle,
          color: "#6E6E6E",
        }}
        fontSize={"14px"}
        fontFamily={"Sitka Heading"}
      >
        {t(subHeading)}
      </Typography>
    </Grid>
  );
};
export default SectionHeading;
